import { vehicleFormSchema } from "./vehicleSchema";
import { mapZodErrors } from "./mapZodErrors";

export {
  VEHICLE_TYPES_REQUIRING_REBOQUE,
  REBOQUE_TRACKED_FIELDS,
  REBOQUE_REQUIRED_FIELDS,
  VEHICLE_FIELD_ORDER,
  REBOQUE_FIELD_ORDER,
  isVehicleTypeRequiringReboque,
  hasValue,
  isReboqueStarted,
  isReboqueComplete,
} from "./constants";

export { VEHICLE_VALIDATION_MESSAGES } from "./messages";
export { vehicleFormSchema } from "./vehicleSchema";
export { mapZodErrors } from "./mapZodErrors";

/**
 * Valida o formulário de veículo com Zod.
 * @returns {{ success: true } | { success: false, fieldErrors: object, messages: string[], firstFieldPath: string|null }}
 */
export const validateVehicleForm = (formData) => {
  const result = vehicleFormSchema.safeParse({
    ...formData,
    reboques: Array.isArray(formData?.reboques) ? formData.reboques : [],
  });

  if (result.success) {
    return { success: true, fieldErrors: {}, messages: [], firstFieldPath: null };
  }

  const mapped = mapZodErrors(result.error);
  return {
    success: false,
    ...mapped,
  };
};

/**
 * Foca e rola até o primeiro campo inválido, quando possível.
 */
export const focusFirstInvalidField = (fieldPath) => {
  if (!fieldPath || typeof document === "undefined") return;

  const selector = `[data-field-path="${fieldPath}"]`;
  const container = document.querySelector(selector);
  if (!container) return;

  container.scrollIntoView({ behavior: "smooth", block: "center" });

  const focusable = container.querySelector(
    "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), .ant-select-selector, button:not([disabled])",
  );

  if (!focusable) return;

  if (focusable.classList?.contains("ant-select-selector")) {
    const selectRoot = focusable.closest(".ant-select");
    const selectInput = selectRoot?.querySelector("input");
    if (selectInput) {
      selectInput.focus();
      return;
    }
  }

  if (typeof focusable.focus === "function") {
    focusable.focus();
  }
};
